export enum ToastVariant {
  BLANK,
  SUCCESS,
  ERROR,
}
